import React from 'react';
import './FormField.css';

export default function FormField({
  label,
  id,
  type = 'text',
  multiline = false,
  value,
  onChange,
  placeholder = '',
  required = false,
  maxLength,
  autoComplete,
  error,
}) {
  return (
    <div className={`form-field ${error ? 'form-field--error' : ''}`}>
      <label className="form-field__label" htmlFor={id}>
        {label}
      </label>
      {multiline ? (
        <textarea
          className="form-field__input form-field__textarea"
          id={id}
          name={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          maxLength={maxLength}
          rows={4}
        />
      ) : (
        <input
          className="form-field__input"
          id={id}
          name={id}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          maxLength={maxLength}
          autoComplete={autoComplete}
        />
      )}
      {error && <span className="form-field__error">{error}</span>}
    </div>
  );
}
